var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAsapPickupicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "illustration_2",
    "data-name": "illustration / 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 95.869,
    height: 83.081,
    viewBox: "0 0 95.869 83.081",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20_Copy",
    "data-name": "Rectangle 20 Copy",
    width: 76,
    height: 76,
    rx: 38,
    fill: "#7a7ed9",
    opacity: 0.143
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Step-04",
    transform: "translate(10 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Step-04-2",
    "data-name": "Step-04",
    transform: "translate(0.665 0.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20_Copy-2",
    "data-name": "Rectangle 20 Copy",
    width: 76,
    height: 76,
    rx: 38,
    fill: "#def9fd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Step-04_Copy",
    "data-name": "Step-04 Copy",
    transform: "translate(0 35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(0 0.449)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(7 7.449)",
    fill: "#fda76b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    "data-name": "Oval",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(14)",
    fill: "#fda76b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M.206,16.5S-1.068,8.748,5.533,4.374s12.43,1.791,12.43,1.791A10.594,10.594,0,0,1,27.73,0c7.282,0,10.054,8.613,3.811,14.293S.206,16.5.206,16.5Z",
    transform: "translate(29.188 3.449)",
    fill: "#7fdcf4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    "data-name": "Oval",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(17 5.449)",
    fill: "#f9fafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval-4",
    "data-name": "Oval",
    d: "M31,29C48.121,29,62,16.016,62,0H0C0,16.016,13.879,29,31,29Z",
    transform: "translate(0 16.449)",
    fill: "#1cc1eb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(43.701 17.721)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 23.441,
    height: 7.402,
    rx: 2.091,
    transform: "translate(10.87 16.805)",
    fill: "#e3945d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    "data-name": "Rectangle",
    width: 23.441,
    height: 7.402,
    rx: 2.091,
    transform: "translate(0.434 15.888) rotate(-19)",
    fill: "#fda76b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_Copy_4",
    "data-name": "Rectangle Copy 4",
    width: 23.441,
    height: 7.402,
    rx: 2.091,
    transform: "translate(30.247 7.916) rotate(21)",
    fill: "#fda76b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_Copy_5",
    "data-name": "Rectangle Copy 5",
    width: 23.441,
    height: 7.402,
    rx: 2.091,
    transform: "matrix(0.985, -0.174, 0.174, 0.985, 10.405, 4.091)",
    fill: "#e3945d"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-3",
    "data-name": "Rectangle",
    d: "M0,0H92.869a0,0,0,0,1,0,0V0a6.611,6.611,0,0,1-6.611,6.611H6.611A6.611,6.611,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(3 41)",
    fill: "#7fdcf4"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M3.695,37.625,8.06,29.718s-6.071-6.2,0-11.094S0,16.521,0,7.344,37.963-3.847,29.761,9.705s-6.013,7.22-6.013,7.22,8.2,2.45,7.108,7.621S19.546,32.3,19.546,32.3Z",
    transform: "translate(37 0)",
    fill: "#fff",
    opacity: 0.389
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsapPickupicon);
export default __webpack_public_path__ + "static/media/asap-pickup.icon.e7f54d92b677753d92fd5017d9ea9490.svg";
export { ForwardRef as ReactComponent };